import React from "react";
import { LoaderIcon, MotorbikeIcon } from "../../../../../utils/svg";
import { formatRupiah } from "../../../../../utils/helper";
import { sendAnalyticsEvent } from "../../../../../utils/helper";

const DeliveryPathnerOption = ({
  selectedPathner = null,
  errors = null,
  touched = null,
  values = {},
  isLoadingDeliveryList = false,
  setValues = () => {},
  setIsShowDelivery = () => {},
  setIsShowBottomSheet = () => {}
}) => {
  return (
    <div
      className={`px-4 mt-4 border-b-8 border-solid pb-4 border-gray-100 ${values?.orderType !== "delivery" ? "hidden" : ""}`}
    >
      <div className="text-gray-900 text-xs font-semibold">Opsi Pengiriman</div>
      <div className="mt-2">
        <div
          className={`border-gray-300 border-1 border-solid rounded-md flex justify-between px-2 py-2.5`}
        >
          <div className="flex items-center">
            <MotorbikeIcon className={`fill-[var(--rose-violet)]`} />
            <div className="pl-2 text-gray-900 text-sm font-semibold">
              {selectedPathner?.name
                ? `${selectedPathner?.name} ${selectedPathner?.serviceType}`
                : "Pilih Pengiriman"}
            </div>
          </div>
          <button
            id="summary_choose_delivery"
            className={`${
              errors?.deliveryType && touched?.deliveryType
                ? "border-red-500 text-red-500"
                : isLoadingDeliveryList
                  ? "border-gray-300 text-[var(--rose-violet)]"
                  : "border-[var(--rose-violet)] text-[var(--rose-violet)]"
            } bg-white border-solid border-1 py-2 px-4 text-xs font-semibold rounded-md min-w-[80px] flex justify-center items-center`}
            disabled={isLoadingDeliveryList}
            onClick={() => {
              setIsShowDelivery(true);
              setIsShowBottomSheet(true);
            }}
          >
            {isLoadingDeliveryList ? (
              <LoaderIcon />
            ) : selectedPathner?.name ? (
              "Ubah"
            ) : (
              "Pilih"
            )}
          </button>
        </div>
        {selectedPathner?.vehicle?.map((type, index) => {
          return (
            <div
              key={`type_${index}`}
              className={`border-1 border-gray-300 border-solid rounded-md flex justify-between px-2 py-2.5 mt-2 items-center ${type?.vehicleTypeCategory === values?.deliveryType?.vehicleTypeCategory ? "" : "bg-gray-100"}`}
              onClick={() => {
                sendAnalyticsEvent(
                  "Select Delivery Type",
                  "summary_select_delivery_type",
                  type?.vehicleTypeCategory
                );
                setValues((prev) => {
                  return {
                    ...prev,
                    deliveryType: type
                  };
                });
              }}
            >
              <div className="">
                <div
                  className={`text-sm capitalize ${type?.vehicleTypeCategory === values?.deliveryType?.vehicleTypeCategory ? "text-gray-900" : "text-gray-500"} font-semibold`}
                >
                  {type?.vehicleType}
                </div>
                <div className="text-xs text-gray-400 pt-1 font-thin">
                  20-30 minute . Max 20 kg
                </div>
              </div>
              <div className="flex">
                <div className="text-gray-500 font-normal text-sm line-through hidden">
                  Rp6.000
                </div>
                <div
                  className={`pl-2 ${type?.vehicleTypeCategory === values?.deliveryType?.vehicleTypeCategory ? "text-gray-900" : "text-gray-500"} font-semibold text-sm`}
                >
                  {formatRupiah((type?.amount || 0) + values?.deliveryFee)}
                </div>
                <div className="pl-2">
                  <input
                    id="transport"
                    type="radio"
                    name="transport"
                    value="bike1"
                    checked={
                      type?.vehicleTypeCategory ===
                      values?.deliveryType?.vehicleTypeCategory
                    }
                    onChange={() => null}
                    className={`${
                      type?.vehicleTypeCategory ===
                      values?.deliveryType?.vehicleTypeCategory
                        ? "!border-[var(--rose-violet)]"
                        : "!border-gray-400 !bg-gray-200"
                    } after:!bg-[var(--rose-violet)] active:bg-white focus:bg-transparent`}
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DeliveryPathnerOption;
